import React from 'react';
import { useCanonicalUrl } from '../../hooks/useCanonicalUrl';
import { seoConfig } from '../../lib/seo';


const Contact: React.FC = () => {
  useCanonicalUrl(seoConfig.contact);

  return (
    <div className="page-container">
      <main className="page-main">
        <header className="page-header">
          <h1>Contact Us</h1>
          <p className="page-description">Have a clever idea for a new filter, or spotted something we could tweak? We're always looking to make LUT Rolls better.</p>
        </header>

        <div className="page-content">
          <div className="content-section">
            <a href="mailto:thelutrolls@duck.com" className="email">thelutrolls@duck.com</a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Contact; 